export const validateResponse = async function (response) {
	if (response.status === 401) {
		window.location.replace("/");
	}
	const responseJson = await response.json();
	return responseJson;
};